/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.exam").
controller("DxExamPreviewController", function examPreviewController(
	$window,
	$scope,

	dxSession,
	NodeRepository,
	DX_GRADING_TYPES,
	DX_SPELLCHECKSETTING,
	DX_NODE_IMAGES,
	DX_QUESTION_TYPE,

	dxLocalize
) {
	"use strict";
	$scope.nodeProfileImage = null;
	$scope.dxSession = dxSession;
	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		if (node.getProfileImage() !== DX_NODE_IMAGES.PROFILE) {
			$scope.nodeProfileImage = node.getProfileImage();
		}
	}

	this.DX_GRADING_TYPES = DX_GRADING_TYPES;
	this.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	this.DX_QUESTION_TYPE = DX_QUESTION_TYPE;

	this.origin = $window.location.protocol + "//" + $window.location.host;
	this.capText = [dxLocalize.get("WordsNoCap"), dxLocalize.get("WordsSoftCap"), dxLocalize.get("WordsHardCap")];
});
